import type { NavigationFeatureConfig } from './type';

export const navigation: NavigationFeatureConfig = {
    settingsDropdown: {
        businessBankingLink: false,
    },
};
